module.exports = __webpack_public_path__ + "static/media/williams stadium.1251cdba.jpeg";